






















































































































import Event from '@/models/event';
import { Component, Prop, Vue } from 'vue-property-decorator';
import log from 'loglevel';

@Component
export default class EventsListItem extends Vue {
  @Prop({ type: Object, required: true }) private event!: Event;
  @Prop({ type: Boolean, default: false }) private expanded!: boolean;
  @Prop({ type: Number, required: true }) private index!: boolean;
  @Prop({ type: Boolean, required: true }) private active!: boolean;

  public resizeTicker: boolean = false;

  public triggerResize(): void {
    this.resizeTicker = !this.resizeTicker;
  }

  public toggleEvent(event: Event) {
    this.$store.commit('toggleEvent', event.code);
  }

  public testTypeText(type?: string): string {
    switch (type) {
      case 'ALPHA TEST': {
        return 'α';
      }
      case 'BETA TEST': {
        return 'β';
      }
      case '': {
        return '';
      }
      case undefined: {
        return '';
      }
    }
    log.error(`Found unknown test type ${type}`);
    return '';
  }

  public itemActionIcon(event: Event) {
    return this.$store.state.agenda.contains(event.code)
      ? 'remove_circle'
      : 'add_circle';
  }

  public itemActionColor(event: Event) {
    return this.$store.state.agenda.contains(event.code)
      ? 'error'
      : 'success';
  }

  public addButtonLabel(event: Event): string {
    return this.$store.state.agenda.contains(event.code)
      ? 'Remove from schedule'
      : 'Add to schedule';
  }

  public expandButtonLabel(event: Event): string {
    return this.expanded
      ? 'Collapse'
      : 'Expand';
  }
}
